<!-- <li class="panel"> -->
<ng-template [ngIf]="pagamento">
<div class="controparte">
	<div>
		<p class="col-sm-2">
			<button (click)="emitEntity(pagamento, beneficiario)"
				class="btn btn-primary associa" type="submit">Allega</button>
		</p>
		<h4 class="titolo col-sm-3">{{beneficiario.persona.nominativo}}</h4>
		<p class="col-sm-2">
			<strong>{{ beneficiario.tipoBeneficiarioPagamento.descrizione }}</strong>
		</p>
		<p class="col-sm-2">
			<strong>{{pagamento.tipoPagamento?.label}}</strong>
		</p>
		<p class="col-sm-4">
			N. autorizzazione: <strong>{{pagamento.numeroAutorizzazione}}
				del {{pagamento.dataAutorizzazione | date:'dd/MM/yyyy'}}</strong>
		</p>
	</div>
</div>
</ng-template>
<!-- </li> -->
